import { useEffect } from 'react';

/**
 * Holding page shown while the real site is still Maeven's content.
 *
 * Rendered from main.tsx instead of <App /> when VITE_COMING_SOON is "true",
 * so none of the site's routes, fonts-heavy pages, or GSAP scroll machinery
 * load behind it. Flip the env var off in Vercel to reveal the real site — no
 * code change and no redeploy of a different branch needed.
 */
export default function ComingSoon() {
  // The real site wants to be indexed; this placeholder does not. Set it here
  // rather than in index.html so the tag disappears the moment the flag is off.
  useEffect(() => {
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex, nofollow';
    document.head.appendChild(meta);

    const previousTitle = document.title;
    document.title = 'Dina Shpunt';

    return () => {
      document.head.removeChild(meta);
      document.title = previousTitle;
    };
  }, []);

  return (
    <main
      dir="rtl"
      className="min-h-[100svh] w-full flex flex-col items-center justify-center
                 px-[1.5rem] py-[3rem] text-center
                 bg-[var(--WhiteBrand-br-100)] text-[var(--BlackBrand)]"
    >
      <h1 className="font-deco text-[clamp(2.25rem,7vw,4.5rem)] leading-[1.1] tracking-[-0.01em]">
        דינה שפונט
      </h1>

      <p
        dir="ltr"
        className="font-main mt-[0.75rem] text-[clamp(0.875rem,2vw,1.125rem)]
                   uppercase tracking-[0.18em] text-[var(--BlackBrand-br-12)]"
      >
        Dina Shpunt
      </p>

      <span
        aria-hidden="true"
        className="my-[2.5rem] block h-[1px] w-[3rem] bg-[var(--BlackBrand-br-12)] opacity-60"
      />

      <p className="font-main text-[clamp(1rem,2.5vw,1.375rem)] leading-[1.6]">
        האתר בבנייה
      </p>
      <p
        dir="ltr"
        className="font-main mt-[0.375rem] text-[clamp(0.875rem,2vw,1rem)] text-[var(--BlackBrand-br-12)]"
      >
        The site is on its way
      </p>

      <a
        href="mailto:livshizm@gmail.com"
        dir="ltr"
        className="font-main mt-[2.5rem] text-[clamp(0.875rem,2vw,1rem)]
                   underline underline-offset-[0.35em] decoration-[var(--BlackBrand-br-12)]
                   transition-colors hover:text-[var(--RedBrand)] hover:decoration-[var(--RedBrand)]
                   focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4
                   focus-visible:outline-[var(--RedBrand)]"
      >
        livshizm@gmail.com
      </a>
    </main>
  );
}
